module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Forever Christmas")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "p0007-01-0"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contents#toc-1"
    }
  }, [_vm._v("PROLOGUE ")]), _c('a', {
    attrs: {
      "id": "page1"
    }
  })]), _c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0007-02-1"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("M")]), _vm._v("ost kids love Christmas. But for me, it was always a big disappointment.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0007-03-4"
    }
  }, [_vm._v("I can still see myself in my pajamas, sitting beneath the Christmas tree, frantically tearing away Santa Claus wrapping paper. I had to get into that next box for my first peek at the newest and greatest gizmo or gadget, the gift I swore up and down would make me eternally happy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0007-03-5"
    }
  }, [_vm._v("And if the present I longed for wasn’t inside the box, I’d feel let down. Maybe even pout a little. If I did get what I wanted, I usually ended up playing with it for a few days, then losing interest and shoving it into the back of my closet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0007-03-6"
    }
  }, [_vm._v("Soon my hopes and dreams would shift to the next big thing, the one that looked oh so cool in the commercials. Yet somehow that too always fell short of my expectations.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0007-03-7"
    }
  }, [_vm._v("No matter how many Christmas gifts I received, I was never satisfied. I kept looking, peering around the back of the tree, hoping to find a package that I’d missed. One more present with my name on the tag.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0007-03-8"
    }
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_vm._v("As years went by, this endless cycle of acquisition and ")]), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_vm._v(" dissatisfaction became a recurring theme in my life. The more I had, the less I appreciated. Life itself became a second-rate toy thrust to the back of the closet, gathering dust.")])]), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0008-02-2"
    }
  }, [_vm._v("Ingratitude became my defining characteristic.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0008-03-4"
    }
  }, [_vm._v("Then along came a snowstorm . . . and a Christmas that changed everything.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc1b7f14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter1.vue
// module id = 69
// module chunks = 0